<template>
    <transition name="fade">
        <div
            v-if="value"
            :class="`${background}-background`"
            class="modal"
            data-close
            @click="close"
        >
            <div class="modal-content">
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'Modal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        background: {
            type: String,
            default: 'blue'
        },
        closable: {
            type: Boolean,
            default: true
        },
        winAudio: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value(val)
        {
            this.$root.modalOpen = val;
            if (val)
            {
                this._audio = this.$audioController.play(
                    this.winAudio ? 'win' : 'open',
                    {delay: 0.2, volume: 0.6}
                );
            }
            else if (this._audio)
            {
                this._audio.stop();
                this._audio = null;
            }
        }
    },
    mounted()
    {
        document.body.appendChild(this.$el);
    },
    beforeDestroy()
    {
        this.$el.remove();
        this.$root.modalOpen = false;
    },
    methods: {
        close(evt)
        {
            if (!this.closable) { return; }
            if ('close' in evt.target.dataset)
            {
                this.$emit('input', false);
            }
        }
    }
};
</script>

<style lang="scss" src="./Modal.scss" />

